import { newRelicBrowserScript } from './newRelicBrowserScript.esm.js';

var _a, _b, _c;
/**
 * Base set of third-party scripts that are applied to all consuming applications by default.
 *
 * - These scripts can be overridden or extended by passing a `thirdPartyScripts` array
 *   to the NucleobaseShell component.
 * - If a script in `thirdPartyScripts` has the same `id` as one in this base list,
 *   it will override the default version.
 */
var baseThirdPartyScripts = [
    (_a = {
            conditions: function () { return process.env.ADOBE_LAUNCH_SCRIPT !== undefined; }
        },
        _a['data-testid'] = 'adobe-launch',
        _a.id = 'AdobeLaunch',
        _a.initializeArea = 'top',
        _a.src = "https://assets.adobedtm.com/".concat(process.env.ADOBE_LAUNCH_SCRIPT),
        _a),
    (_b = {
            conditions: function () { return process.env.COOKIE_BOT_ID !== undefined; }
        },
        _b['data-cbid'] = process.env.COOKIE_BOT_ID,
        _b['data-testid'] = 'cookiebot',
        _b.id = 'Cookiebot',
        _b.initializeArea = 'bottom',
        _b.src = 'https://consent.cookiebot.com/uc.js',
        _b),
    (_c = {
            conditions: function () {
                return process.env.NEW_RELIC_LICENSE_NUMBER !== undefined && process.env.NEW_RELIC_APPLICATION_ID !== undefined;
            }
        },
        _c['data-testid'] = 'newrelic',
        _c.id = 'NewRelic',
        _c.initializeArea = 'top',
        _c.scriptSnippet = newRelicBrowserScript,
        _c),
];
/* eslint-enable spellcheck/spell-checker */

export { baseThirdPartyScripts as default };
//# sourceMappingURL=baseThirdPartyScripts.esm.js.map
